var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24 Emoji/Smileys") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24-Emoji/Smileys",
    fill: "#000001",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.250000, 0.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75,0 C5.26065755,0 0,5.26065755 0,11.75 C0,18.2393425 5.26065755,23.5 11.75,23.5 C18.2393425,23.5 23.5,18.2393425 23.5,11.75 C23.5,5.26065755 18.2393425,0 11.75,0 Z M11.75,1.5 C17.4109153,1.5 22,6.08908467 22,11.75 C22,17.4109153 17.4109153,22 11.75,22 C6.08908467,22 1.5,17.4109153 1.5,11.75 C1.5,6.08908467 6.08908467,1.5 11.75,1.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08333333,9.93333333 C7.46661222,9.93333333 6.96666667,9.43338778 6.96666667,8.81666667 C6.96666667,8.24106029 7.40217479,7.76717841 7.96165965,7.70655241 L8.08333333,7.7 L8.08333333,8.43333333 C8.29503934,8.43333333 8.46666667,8.60496066 8.46666667,8.81666667 C8.46666667,9.02837267 8.29503934,9.2 8.08333333,9.2 L8.08333333,9.93333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7,8.81666667 C7.7,8.60496066 7.87162733,8.43333333 8.08333333,8.43333333 L8.08333333,7.7 C8.70005445,7.7 9.2,8.19994555 9.2,8.81666667 C9.2,9.39227304 8.76449188,9.86615492 8.20500702,9.92678092 L8.08333333,9.93333333 L8.08333333,9.2 C7.87162733,9.2 7.7,9.02837267 7.7,8.81666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4166667,9.93333333 C14.799955,9.93333333 14.3,9.4333875 14.3,8.81666667 C14.3,8.24106056 14.7355164,7.76717844 15.2949946,7.70655241 L15.4166667,7.7 L15.4166667,8.43333333 C15.628376,8.43333333 15.8,8.60495419 15.8,8.81666667 C15.8,9.02837914 15.628376,9.2 15.4166667,9.2 L15.4166667,9.93333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0333333,8.81666667 C15.0333333,8.60495419 15.2049574,8.43333333 15.4166667,8.43333333 L15.4166667,7.7 C16.0333783,7.7 16.5333333,8.19994583 16.5333333,8.81666667 C16.5333333,9.39227278 16.0978169,9.86615489 15.5383387,9.92678092 L15.4166667,9.93333333 L15.4166667,9.2 C15.2049574,9.2 15.0333333,9.02837914 15.0333333,8.81666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49950837,14.0113036 C5.87066015,13.8274035 6.32061857,13.979201 6.50451863,14.3503528 C6.98858128,15.3273004 7.73599098,16.1495708 8.6625211,16.7245729 C9.58905063,17.2994827 10.6576892,17.6041067 11.7480444,17.6041067 C12.8384011,17.6041067 13.9070516,17.2994819 14.8335327,16.7246129 C15.7600626,16.1495732 16.5074791,15.327288 16.9915797,14.3503337 C17.1754904,13.9791871 17.6254531,13.8274024 17.9965997,14.0113131 C18.3677462,14.1952237 18.5195309,14.6451865 18.3356203,15.016333 C17.7274399,16.2436902 16.7884697,17.2767171 15.6244598,17.9991459 C14.4604446,18.7214015 13.1178815,19.1041067 11.7480444,19.1041067 C10.3782056,19.1041067 9.03565021,18.7214005 7.87160741,17.9991142 C6.70759369,17.2767304 5.76860838,16.2436961 5.16045914,15.0163138 C4.97655908,14.6451621 5.1283566,14.1952036 5.49950837,14.0113036 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileys);
export default __webpack_public_path__ + "static/media/smileys.947dc6572c40c9850c952e659549af40.svg";
export { ForwardRef as ReactComponent };